import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Button, notification } from 'antd';
import { TOKEN_REFRESH } from '../state/auth/types';
import { USER_LOGOUT } from '../state/token/types';
import PropTypes from 'prop-types';

/**
 * Component that returns a notification.
 * @component
 * @returns {Element} Notification when token expires
 */
const RefreshTokenNotification = props => {
  const {
    refreshToken,
    expiresIn,
    getNewToken,
    logout
  } = props;

  let notificationTimer;
  let logoutTimer;
  const date = new Date();
  const [expirationTime, setExpirationTime] = useState(expiresIn);

  useEffect(() => { setExpirationTime(expiresIn); }, [expiresIn]);

  const sendNotification = () => {
    getNewToken(refreshToken);
  };

  const openNotification = () => {
    const key = 'notification';
    const btn = (
      <Button type="primary" onClick={() => { notification.close(key); sendNotification(); }}>
        Necesito más tiempo
      </Button>
    );
    notification.open({
      message: '¿Necesita más tiempo?',
      description: 'Su sesión esta a punto de expirar, si desea continuar haga click en el boton "necesito más tiempo".',
      duration: 0,
      btn,
      key,
    });
  };

  const showAsert = () => {
    const expiresInMs = expirationTime * 1000;
    const timeBeforeExpiration = (expiresInMs - 900000) - date; //notification scheduled 15 minutes before token expires - 900000 ms
    const tokenExpiration = expiresInMs - date;
    clearTimeout(notificationTimer);
    clearTimeout(logoutTimer);
    notificationTimer = setTimeout(() => { openNotification(); }, timeBeforeExpiration);
    logoutTimer = setTimeout(() => { logout(); }, tokenExpiration);
    if (date >= expiresInMs) logout();
  };

  useEffect(() => { if (expirationTime > 0) showAsert(); }, [expirationTime]);

  return (<></>);
};

RefreshTokenNotification.propTypes = {
  /**
   * Param used to dispatch getNewToken
   */
  refreshToken: PropTypes.string.isRequired,
  /**
   * Function that dispatches renew the token
   */
  getNewToken: PropTypes.func.isRequired,
  /**
   * Function that dispatch logout action
   */
  logout: PropTypes.func.isRequired,
  expiresIn: PropTypes.string,
};

const data = state => ({
  refreshToken: state.auth.refreshToken,
  expiresIn: state.auth.expiresIn,
});

const actions = dispatch => ({
  getNewToken: data => dispatch({ type: TOKEN_REFRESH, payload: data }),
  logout: () => dispatch({ type: USER_LOGOUT }),
});

export default connect(data, actions)(RefreshTokenNotification);